import React, { useContext, useState } from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { GlobalContext } from "../../Utils/Contexts";
import { useLazyQuery } from "@apollo/client";
import { getAirportsLike } from "../../GQL/queries";
import { AirportsLike } from "../../Generated/avroGraphqlDuty";
import { State } from "../../PilotDuty/PilotDutyPage";
import { PilotDutyErrorHelper } from "../../Utils/PilotDutyErrorHelper";

interface Props {
    sourceProperty: string;
    initialValue: string | undefined;
    labelText: string;
    isRequired: boolean;
    payloadProperty: string;
    localState: State;
    dutyItemId: number;
    setLocalState(arg0: State): void;
    onBlurSelects(): void;
}

interface LocalState {
    options: string[];
    selectedValue: string | undefined;
    inputValue: string;
}

export default function LocationSelector(props: Props): JSX.Element {
    const [getAirportLikeQuery] = useLazyQuery(getAirportsLike, {
        onCompleted(data) {
            const rawList = data.getAirportsLike.slice() as AirportsLike[];
            const airportsLikeListToPresent: string[] = rawList.map((airportsLike) => airportsLike.airport_code);

            setLocalState({
                ...localState,
                options: airportsLikeListToPresent,
            });
        },
    });
    const [localState, setLocalState] = useState<LocalState>({
        options: [],
        inputValue: props.initialValue !== undefined ? props.initialValue : "",
        selectedValue: props.initialValue !== undefined ? props.initialValue : "",
    } as LocalState);

    const context = useContext(GlobalContext);

    const handleOnInputChange = (e: React.SyntheticEvent, value: string | AirportsLike | null): void => {
        setLocalState({ ...localState, inputValue: value ? value.toString().toUpperCase() : "" });
        if (value && value.toString().length !== 4 && value.toString().length > 1) {
            // length is 4 then the airport code is already complete
            getAirportLikeQuery({ variables: { input: value } });
        }
    };

    const handleOnChange = (e: React.SyntheticEvent, value: string | null): void => {
        setLocalState({
            ...localState,
            selectedValue: `${value ?? ""}`,
        });
        const newDutyItemsList = props.localState.PilotDuty?.DutyItems?.map((l) =>
            l && l.id === props.dutyItemId ? { ...l, [`${props.payloadProperty}`]: `${value ?? ""}` } : l
        );
        props.setLocalState({ ...props.localState, HasChanges: true, PilotDuty: { ...props.localState.PilotDuty, DutyItems: newDutyItemsList } });
    };

    return (
        <>
            <Autocomplete
                value={localState.selectedValue}
                inputValue={localState.inputValue}
                options={localState.options}
                onChange={handleOnChange}
                onInputChange={handleOnInputChange}
                onBlur={props.onBlurSelects}
                filterSelectedOptions
                style={{ textTransform: "uppercase" }}
                renderInput={(params) => (
                    <TextField
                        required={props.isRequired}
                        {...params}
                        label={props.labelText}
                        placeholder="type to search"
                        error={PilotDutyErrorHelper.hasErrors(props.localState.Errors, props.sourceProperty, props.dutyItemId)}
                        helperText={PilotDutyErrorHelper.getErrorMessage(props.localState.Errors, props.sourceProperty, props.dutyItemId)}
                    />
                )}
            />
        </>
    );
}
